<template>
  <v-app theme="pdsLightTheme">
    <GlobalSnackbar />
    <BMS3Header />
    <v-main>
      <v-banner
        class="align-center errorMessage"
        v-if="!isOnline"
        sticky
        style="top: 48px; z-index: 1001"
      >
        <v-banner-text>
          OFFLINE - Don't clear your cache or you will lose data.
        </v-banner-text>
      </v-banner>
      <page-loading />
      <Suspense><router-view></router-view></Suspense>
    </v-main>
  </v-app>
</template>

<script>
import BMS3Header from "@/components/header/BMS3Header.vue";
import PageLoading from "@/components/loading/PageLoading.vue";
import GlobalSnackbar from "@/components/globalSnackbar/GlobalAppSnackbar.vue";
import { defineComponent, onBeforeUnmount, onMounted, computed } from "vue";
import { useConfigStore } from "@/stores/config";
import { useConnectivityStore } from "@/stores/connectivity";
import { setupSyncInterval } from "@/util/syncInterval";
import { useUserStore } from "@/stores/userStore";

export default defineComponent({
  setup() {
    const configStore = useConfigStore();
    const connectivity = useConnectivityStore();
    const userStore = useUserStore();
    let isOnline = computed(() => connectivity.getOnlineServiceStatus);

    onMounted(() => {
      configStore.loadAppBuildInfo();
      connectivity.addListeners();
      connectivity.getServiceStatus();
      //Set up backgroud process to auto sync inspection data.
      setupSyncInterval();
    });
    onBeforeUnmount(() => {
      connectivity.removeListeners();
    });

    
    return { userStore, isOnline };
  },
  components: {
    BMS3Header,
    GlobalSnackbar,
    PageLoading,
  },
});
</script>
